// extracted by mini-css-extract-plugin
export default {"mid-box":"NonFaceComplete_mid-box__MjzQe","top":"NonFaceComplete_top__flnOI","mid":"NonFaceComplete_mid__ytnvI","botm":"NonFaceComplete_botm__CyVsn"};